import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Prevents authenticated users from reaching public auth pages (login, signup, forgot-password). */
@Injectable({ providedIn: 'root' })
export class LoginPageGuard  {
  constructor(private _auth: AuthService, private _router: Router) {}

  canActivate(): boolean {
    if (this._auth.isAuthenticated()) {
      this._router.navigate(['/']);
      return false;
    }
    return true;
  }
}
